import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

interface CampaignInstructionBannerProps {
  message: string;
  onBehalfOfLogin?: string;
  respondByDate?: string;
}

export const CampaignInstructionBanner: FC<CampaignInstructionBannerProps> = ({
  message,
  onBehalfOfLogin,
  respondByDate,
}) => (
  <MessageBanner type={MessageBannerType.Informational} isDismissible>
    {onBehalfOfLogin
      ? `${getString("campaigns.respondingOnBehalf", { login: onBehalfOfLogin })} `
      : null}
    {message}
    {respondByDate
      ? ` ${getString(
          onBehalfOfLogin
            ? "campaigns.respondBy"
            : "campaigns.respondByWithManagerFollowUp",
          { date: respondByDate }
        )}`
      : null}
  </MessageBanner>
);
